import { connect } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { customerGridChangePage } from '../../../../store/customers/grid/customers.grid.actions';
import { PagingControl } from '../../../../components/paging-control';

const mapStatesToProps = (state) => {
  return {
    page: Global.selectCustomersGridPage(state),
    pageSize: Global.selectCustomersGridPageSize(state),
    totalPages: Global.selectCustomersGridTotalPages(state),
    totalRecords: Global.selectCustomersGridTotalRecords(state),
    viewStartingCount: Global.selectCustomersGridViewStartingCount(state),
    viewEndingCount: Global.selectCustomersGridViewEndingCount(state),
    numberSelected: Global.selectSelectedCustomersCount(state),
  };
};

const mapDispatchToProps = { onPageChange: customerGridChangePage };

export default connect(mapStatesToProps, mapDispatchToProps, null, {
  pure: false,
})(PagingControl);
